import React from "react";

type GridColumnProps = React.PropsWithChildren<{
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    xxl?: number;
    xxxl?: number;
    style?: React.CSSProperties;
}>;

export const GridColumn: React.FunctionComponent<GridColumnProps> = (props: GridColumnProps) => {
    const { sm, md, lg, xl, xxl, xxxl } = {
        sm: `${`ms-sm${props.sm || 12} `}`,
        md: `${props.md ? `ms-md${props.md} ` : ``}`,
        lg: `${props.lg ? `ms-md${props.lg} ` : ``}`,
        xl: `${props.xl ? `ms-md${props.xl} ` : ``}`,
        xxl: `${props.xxl ? `ms-md${props.xxl} ` : ``}`,
        xxxl: `${props.xxxl ? `ms-md${props.xxxl} ` : ``}`
    };

    return (
        <div className={`ms-Grid-col ${sm}${md}${lg}${xl}${xxl}${xxxl}`} style={props.style}>
            {props.children}
        </div>
    );
};
